import React from 'react';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';
import { Box, Grid } from '@mui/material';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { parseHTML } from '@/utils/parseHTML';

interface DpPopulateContainerProps {
	children: React.ReactNode;
	title?: string;
	icon?: string;
}
export const DpPopulateContainer: React.FC<DpPopulateContainerProps> = ({
	children,
	title,
	icon,
}) => (
	<DpBottomContainer isPopulate framesx={{ backgroundColor: 'white' }}>
		{title ? (
			<Grid
				sx={{
					display: 'flex',
					flexDirection: 'row',
					maxWidth: '1280px',
					width: '100%',
					marginBottom: { xs: 0, sm: 'var(--spacing-8)' },
					justifyContent: 'start',
					alignItems: 'center',
				}}
			>
				{icon ? <Box sx={{ fontSize: '30px' }}>{parseHTML(icon)}</Box> : null}
				<DpH2 sx={{ marginBottom: 0 }}>{title}</DpH2>
			</Grid>
		) : null}
		<Box
			sx={{
				display: { xs: 'block', md: 'flex' },
				justifyContent: { xs: 'flex-start', md: 'space-between' },
			}}
		>
			{children}
		</Box>
	</DpBottomContainer>
);
